import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const box = css`
  inline-size: 100%;
`

export const grid = css`
  display: flex;
  inline-size: 100%;
  justify-content: space-between;
  margin-inline-end: ${spacing(1)};
`

export const centeredText = css`
  justify-content: center;
`

export const trailless = css`
  margin-inline-end: 0;
`
